<p-toast [position]="'top-right'"></p-toast>
<ng-container *ngIf="user$ | async as user; else showLoginButtonOnly">
  <p-menubar>
    <ng-template pTemplate="start">
      <div class="col-12 flex overflow-hidden">
        <div class="flex-none flex align-items-center justify-content-center">
          <img src="assets/tamer_logo.png" height="60" class="mr-2" alt="App Logo">
          <p-divider layout="vertical" />
          <img src="assets/shopping_online.png" height="50" class="ml-4 mr-2" alt="App Logo">
          <h2 class="ml-1" style="vertical-align: middle; display: inline;">TATC Digital Hub AI Workbench</h2>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="end">
      <div class="col-12 flex overflow-hidden">
        <div class="flex-grow-1 flex align-items-center justify-content-center"></div>
        <div class="flex-none flex align-items-center justify-content-center mr-4">
          <p-button label="New Session" icon="pi pi-plus" variant="text" (click)="addNewSession()" size="large"
            severity="info"></p-button>
          <app-incident-list></app-incident-list>
          <app-task-list></app-task-list>
          <app-approval-list></app-approval-list>
          <app-notification-list></app-notification-list>
          <button pButton label="Archive" type="button" routerLink="/session-archive" icon="pi pi-comments"
            severity="info"></button>
        </div>
        <div class="flex-none flex align-items-center justify-content-center">
          <div *ngIf="adminUser"
            class="bg-green-100 border-round-md pt-2 pb-2 pl-2 pr-4 flex align-items-center flex-wrap cursor-pointer user-profile-menu"
            (click)="accountMenu.toggle($event)">
            <div class="flex align-items-center justify-content-center">
              <p-avatar [image]="adminUser.profilePictureUrl || 'assets/manager.png'" styleClass="mr-2 ml-2"
                size="large" shape="circle"></p-avatar>
            </div>
            <div class="flex flex-column align-items-start justify-content-center">
              <div class="flex flex-row"><b class="p-menuitem-text">{{adminUser.fullName}}</b></div>
              <div class="flex flex-row"><small>{{adminUser.roles?.at(0)?.roleName}}</small></div>
              <div class="flex flex-row"><small class="build-info-inline">Version {{ buildVersion }} | {{
                  environmentName }}</small></div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-menubar>
  <p-menu #accountMenu [model]="accountMenuItems" [popup]="true"></p-menu>
</ng-container>

<ng-template #showLoginButtonOnly>
  <!-- Optionally, you could place a simplified header or just the login button here if needed when not logged in,
       but for now, we'll just hide the main menubar. The login page will render via router-outlet. -->
  <!-- Example: <p-button label="Login" icon="pi pi-sign-in" (click)="navigateToLogin()" *ngIf="router.url !== '/login'"></p-button> -->
</ng-template>
<div class="col-6 align-items-end">

</div>
<div class="page-content-menubar-layout">
  <router-outlet></router-outlet>
</div>

<p-confirmDialog></p-confirmDialog>
<app-file-viewer></app-file-viewer>